import { defineComponent, ref } from 'vue'
import Breadcrumbs from '@/components/breadcrumbs'
import RightMenu from '@/components/right-menu'
import Logout from '@/components/logout'
import MobileMenu from '@/components/mobile-menu'
import DeliveryMethod from './DeliveryMethod'
import PickupMethod from './PickupMethod'
import './delivery_edit.sass'

export default defineComponent({
  setup () {
    const deliveryMethod = ref<string>('')
    const sendSuccess = ref<boolean|undefined>(undefined)

    return () => {
      return (
        <div class="delivery-edit-page">
          <Breadcrumbs items={[{ name: 'Главная', link: '/' }, { name: 'История заявок', link: '#' }]}/>
          <h1 class="page-title">Изменение условий доставки заказа № 3662588</h1>
          <div class="main-content-two-columns">
            {sendSuccess.value === undefined
              ? (
                <div class="delivery-edit-block">
                  <p>Укажите способ доставки</p>
                  <div class="delivery-edit-select">
                    <input type="radio" name="delivery_method" id="delivery" value="delivery" onClick={ () => { deliveryMethod.value = 'delivery' } } />
                    <label for='delivery'>Доставка</label>
                    <input type="radio" name="delivery_method" id="pickup" value="pickup" onClick={ () => { deliveryMethod.value = 'pickup' } } />
                    <label for='pickup'>Самовывоз</label>
                  </div>
                  <div class="delivery-edit-block-form">
                    {deliveryMethod.value === 'delivery'
                      ? (
                        <DeliveryMethod deliveryMethod={deliveryMethod.value} isCompany={true} onSendSuccess={ (value: any) => { sendSuccess.value = value } } />
                      )
                      : null
                    }
                    {deliveryMethod.value === 'pickup'
                      ? (
                        <PickupMethod deliveryMethod={deliveryMethod.value} isCompany={false} onSendSuccess={ (value: any) => { sendSuccess.value = value } } />
                      )
                      : null
                    }
                  </div>
                  {deliveryMethod.value === ''
                    ? (
                      <span>
                        Доставка транспортной компанией - по готовности продукции к отгрузке, согласно условиям счета,<br/>
                        Ваш заказ будет передан в транспортную компанию для отправки в Ваш адрес.<br/>
                        Информация для отслеживания отправления, будет предоставлена Вам дополнительно.
                      </span>
                    )
                    : null
                  }
                </div>
              )
              : null
            }
            {sendSuccess.value === true
              ? (
                <div class="success-block">
                  <div class="success-icon" />
                  <p>Благодарим за уделенное время! <br/> Данные записаны и переданы в службу логистики</p>
                </div>
              ) : null
            }
            {sendSuccess.value === false
              ? (
                <div class="error-block">
                  <div class="error-icon"/>
                  <p>Произошла ошибка! <br/> Попробуйте повторить отправку позже</p>
                </div>
              ) : null
            }
            <div class="main-content-two-columns-right">
              <div class="main-content-two-columns-right-elem-sticky">
                <RightMenu/>
                <Logout/>
                <MobileMenu/>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
})